import * as React from 'react';
import { observer } from 'mobx-react';

import { FeedItemContainer } from './FeedItemContainer';
import { FeedItemContent } from './FeedItemContent';
import {InlineQuiz} from "components/quiz/InlineQuiz";
import {TableChart} from "components/chart/TableChart";
import {HeaderLevelCorrectedContent} from "components/feed/FeedItem/HeaderLevelCorrectedContent";
import {FeedItemContextType} from "components/feed/FeedItem/FeedItem";

interface IFeedItemQuizProps {
  feedItem:any;
  updateFeedItem:(feedItem:any, skipUpdatingPoints?:boolean)=>void;
  feedItemContext:FeedItemContextType;
}

@observer
export class FeedItemQuiz extends React.Component<IFeedItemQuizProps> {
  render() {
    var icon = (this.props.feedItem.icon ? this.props.feedItem.icon : (this.props.feedItem._post.icon?this.props.feedItem._post.icon:"icon-clipboard"));
    var title = this.props.feedItem._post.title;	
    var points = (this.props.feedItem._post.pointValue?<div className="text">{this.props.feedItem._post.pointValue} pts.</div>:"")

    // Is this an active Quiz
    if(this.props.feedItem.step<this.props.feedItem._post.steps.length) {
      return (
        <FeedItemContainer completed={this.props.feedItem.completed} extraClassName="inlineQuiz">
          <span className="solution" aria-hidden={true}><i className={icon}/>{points}</span>
          <FeedItemContent title={title} feedItemContext={this.props.feedItemContext}>
            <InlineQuiz
              feedItem={this.props.feedItem}
              updateFeedItem={this.props.updateFeedItem}
              feedItemContext={this.props.feedItemContext}
            />
          </FeedItemContent>
        </FeedItemContainer>
      );

    // Is this a chart as a result of a quiz
    } else if(this.props.feedItem._post.isChartable) {
      // table chart of only the answers provided to this quiz that loads another graph
      return (
        <FeedItemContainer completed={this.props.feedItem.completed} extraClassName="inlineChart">
          <span className="solution"><i className={icon}/>{points}</span>
          <FeedItemContent title={this.props.feedItem._post.title} feedItemContext={this.props.feedItemContext}>
            <TableChart feedItem={this.props.feedItem} />
          </FeedItemContent>
          <div>
              {this.props.feedItem.pointsAwarded?<div className="points"><div>+</div><div><div className="circ"><div>{this.props.feedItem.pointsAwarded}</div></div></div></div>:""}							
          </div>
        </FeedItemContainer>
      );

    } else {
      return (
        <FeedItemContainer completed={this.props.feedItem.completed} extraClassName="inlineQuiz">
          <span className="solution"><i className={icon}/>{points}</span>
          <div>					
              <FeedItemContent title={title} feedItemContext={this.props.feedItemContext} >
                <HeaderLevelCorrectedContent className="text" content={this.props.feedItem._post.content} offset={this.props.feedItemContext} />
              </FeedItemContent>
          </div>
          <div>
              {this.props.feedItem.pointsAwarded?<div className="points"><div>+</div><div><div className="circ"><div>{this.props.feedItem.pointsAwarded}</div></div></div></div>:""}							
          </div>
        </FeedItemContainer>			
      );
    }
  }

}

